import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import { retrieveDriverProfile } from "../../actions/commonActions";
import RegisterVehicle from "../Vehicles/RegisterVehicle";
import VehiclesList from "../Vehicles/VehiclesList";
import { setPageTitle } from "../../utils/helper";

export default function Profile() {
  const dispatch = useDispatch();
  const [addNewVehicle, setAddNewVehicle] = useState(false);
  const urlParams = useParams();
  const [profileId, setProfileId] = useState(undefined);
  const history = useHistory();

  // Read from redux state
  const { driverProfile } = useSelector((reduxState) => reduxState);
  const { userAccount, vehicles } = driverProfile;

  const [showDoneButton, setShowDoneButton] = useState(
    localStorage.getItem("showDoneButton")
  );
  // ===========
  useEffect(() => {
    let { id } = urlParams;
    setProfileId(id);
    retrieveDriverProfile(dispatch, id);
    setPageTitle("Profile");
  }, []);

  let first_name = "";
  let last_name = "";

  useEffect(() => {
    if (!userAccount.person.first_name || !userAccount.person.last_name) {
      first_name = localStorage.getItem("first_name");
      last_name = localStorage.getItem("last_name");
    }
  });

  const profileCompleted = () => {
    // *********************  Mobile app stuff ***********************
    // IOS
    if (window.webkit) {
      window.webkit.messageHandlers.profile.postMessage({
        completed: true,
      });
    }
    // =====

    // Android
    if (window.androidObj == undefined) {
      window.androidObj = function AndroidClass() { };
    }

    if (window.androidObj.profileCompleted !== undefined) {
      window.androidObj.profileCompleted(true);
    }
    // ======
    // *********************  Mobile app stuff ***********************
    localStorage.removeItem("showDoneButton");
    setShowDoneButton(false);
  };
  return (
    <div className="container mt-1" style={{ width: "100%" }}>
      <form>
        <div className="">
          <div className="row">
            <div className="col-6"></div>
            <div className="col-6">
              <div>
                {showDoneButton == "true" && (
                  <button
                  style={{color:"rgb(100 100 100 / 1)"}}
                    type="button"
                    className="btn btn-success float-right green-one-bg"
                    onClick={profileCompleted}
                  >
                    Done
                  </button>
                )}
              </div>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-8">
              <h4>Contact information</h4>
            </div>
            <div className="col-4">
              {/* <a
                href={`/profile/${profileId}/edit`}
                className={`btn btn-default btn-block float-right mb-2`}
              >
                Edit
              </a>{" "} */}

              <button
                type="button"
                className="btn btn-default btn-block float-right mb-2"
                onClick={() => history.push(`/profile/${profileId}/edit`)}
              >
                Edit
              </button>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-8">
              <h4>Vehicles</h4>
            </div>
            {(addNewVehicle && (
              <RegisterVehicle setAddNewVehicle={setAddNewVehicle} />
            )) || (
                <div className="col-4">
                  <button
                    type="button"
                    className="btn btn-default btn-block float-right mb-2"
                    onClick={() => setAddNewVehicle(true)}
                  >
                    Add
                  </button>
                </div>
              )}
          </div>
          <VehiclesList vehicles={vehicles} />
        </div>
      </form>
    </div>
  );
}
